import { Command } from 'ckeditor5/src/core';
import { findDescendant } from '../utils';
import { COMPONENT_ATTR_ID, COMPONENT_ATTR_NAME, COMPONENT_ATTR_UPDATING, COMPONENT_NAME, OUT_COMMANDS } from '../constants';
import { isEmpty } from 'lodash';

export default class EditableFieldSetIsUpdatingCommand extends Command {
	execute( data ) {
		if ( !data || !data.id || isEmpty( data.id ) || !data.name || isEmpty( data.name ) ) {
			return;
		}

		const id = data.id;
		const name = data.name;
		const value = !!data.value;
		const editor = this.editor;
		const config = editor.config.get( 'editableField' );
		const allowValuePropagation = config && config.allowValuePropagation;

		editor.model.change( writer => {
			const elements = findDescendant( editor.model.document.getRoot(), element => {
				return (
					element &&
          element.is( 'element', COMPONENT_NAME ) &&
					( allowValuePropagation || element.getAttribute( COMPONENT_ATTR_ID ) === id ) &&
          element.getAttribute( COMPONENT_ATTR_NAME ) === name
				);
			} );
			if ( elements.length > 0 ) {
				elements.forEach( elem => {
					if ( value ) {
						writer.setAttribute( COMPONENT_ATTR_UPDATING, value, elem );
					} else {
						writer.removeAttribute( COMPONENT_ATTR_UPDATING, elem );
					}
				} );
				this.fire( OUT_COMMANDS.SET_IS_UPDATING, {
					name,
					value,
					type: 'ok'
				} );
			} else {
				this.fire( OUT_COMMANDS.SET_IS_UPDATING, {
					name,
					message: 'Not found element with name',
					type: 'error'
				} );
			}
		} );
	}
}
